import { createTheme } from '@one-thd/sui-atomic-components';

const DecorDaysYellow = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

DecorDaysYellow.palette['--sui-palette-background-primary'] = '248 184 85';

export { DecorDaysYellow };
